import * as tslib_1 from "tslib";
import { ConvertUtils } from 'cc-common';
import { Transform, Type } from 'class-transformer';
import { AllowActionResultDto } from '../../common/allow-action-result-dto';
const ɵ0 = () => Date, ɵ1 = () => Date, ɵ2 = () => Date, ɵ3 = () => Date, ɵ4 = () => Date;
export class CashReceiptResultDto extends AllowActionResultDto {
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Date)
], CashReceiptResultDto.prototype, "receiveDate", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Date)
], CashReceiptResultDto.prototype, "postDate", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Date)
], CashReceiptResultDto.prototype, "transactionDate", void 0);
tslib_1.__decorate([
    Type(ɵ3),
    tslib_1.__metadata("design:type", Date)
], CashReceiptResultDto.prototype, "reversedDate", void 0);
tslib_1.__decorate([
    Transform(ConvertUtils.toNullableString),
    tslib_1.__metadata("design:type", String)
], CashReceiptResultDto.prototype, "customer", void 0);
tslib_1.__decorate([
    Type(ɵ4),
    tslib_1.__metadata("design:type", Date)
], CashReceiptResultDto.prototype, "updatedTime", void 0);
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4 };
